import z from 'zod';
export const changePrestationAccountSchema = z.object({
    financialAccountId: z.number().int().positive('Le compte est requis'),
});
